export default "__VITE_ASSET__C56YdeYt__"